import React from "react";
import { MonthFilters } from "./MonthFilters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./monthHelpers";
import { mapFilterValuesToInstructionExternal, mapResponseToFilterValuesExternal } from "./monthHelpersExternal";
import { PlanningTemplate } from "./PlanningTemplate";
import { MonthNavigationFilter } from "components/filters/components/MonthNavigationFilter";
import { useLoaderData } from "react-router";

export const PlanningMonthInternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MonthViewForInternalFrontModel>();

  return <PlanningTemplate
    filterSet="planning_Month"
    initialInstruction={viewModel.initialInstruction}
    defaultFilters={viewModel.defaultFilters}
    fetchFunction={window.CoreApi.Planning.PlanningByMonth}
    mapFilterValuesToInstruction={mapFilterValuesToInstruction}
    mapResponseToFilterValues={mapResponseToFilterValues}
    filterComp={<MonthFilters />}
    paginationComp={<MonthNavigationFilter />}
    maxEntriesPerColumn={5}
    filterPreset={{
      mutateApi: window.CoreApi.FilterPreset.CreateFilterPresetForPlanningByMonth,
      listApi: window.CoreApi.FilterPreset.ListFilterPresetsForPlanningByMonth
    }}
  />
};

export const PlanningMonthExternalApp = () => {
  const viewModel = useLoaderData<server.viewmodel.MonthViewForExternalFrontModel>();

  return <PlanningTemplate
    filterSet="planning_Month"
    initialInstruction={viewModel.initialInstruction}
    defaultFilters={viewModel.defaultFilters}
    fetchFunction={window.CoreApi.Planning.PlanningByMonth}
    mapFilterValuesToInstruction={mapFilterValuesToInstructionExternal}
    mapResponseToFilterValues={mapResponseToFilterValuesExternal}
    filterComp={<MonthFilters external />}
    paginationComp={<MonthNavigationFilter />}
    maxEntriesPerColumn={5}
  />
};
